<template>
  <div :class="$style.record">
    <div :class="$style.mask"></div>
    <div :class="$style.context">
      <div :class="$style.window">
        <h1>概率公示</h1>
        <ul :class="$style.col">
          <li v-for="item in recordList" :key="item.award">
            <span>{{ item.award }}</span>
            <span>{{ item.probability + '%' }}</span>
          </li>
        </ul>
      </div>
      <i class="iconfont yw-close" @click="$emit('close')"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    recordList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  components: {},
};
</script>

<style lang="scss" module>
.lighter {
  color: #3cc0ff;
}
@mixin border-bottom-1px($left: 0, $width: 100%) {
  position: relative;
  &:before {
    display: block;
    position: absolute;
    left: $left;
    bottom: 1px;
    width: $width;
    border-top: 1px solid #ececec;
    content: " ";
    z-index: 1;
  }
}

.record {
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
  }
  .context {
    position: absolute;
    width: 351px;
    height: 365px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    color: #9f9f9f;
    .window {
      width: 351px;
      height: 305px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px;
      > h1 {
        color: #000000;
        font-size: 15px;
        margin-bottom: 18px;
        text-align: center;
      }
      .col {
        border: 1px solid #dfdfdf;
        overflow-y: auto;
        height: 210px;
        > li {
          border-bottom: 1px solid #dfdfdf;
          display: flex;
          justify-content: space-evenly;
          font-size: 0;
          > span {
            width: 50%;
            padding-left: 18px;
            line-height: 25px;
            font-size: 13px;
          }
          > span:nth-child(1) {
            border-right: 1px solid #dfdfdf;
          }
        }
        > li:nth-last-child(1) {
          border: none;
        }
      }
    }
    :global {
      .yw-close {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        color: #ffffff;
        font-size: 50px;
        z-index: 1;
        margin: auto;
        font-weight: 100;
      }
    }
  }
}
</style>